import type { WebsiteLink } from "../components/WebsiteGrid";

export const mapsData: WebsiteLink[] = [

  
   // World Maps
  {
    id: "world-001",
    title: "Ping Pong Map",
    url: "https://www.pingpongmap.net/",
    imageUrl: "https://mapfinder.org/images/pingpongmap_net.jpg",
    description: "A map to find places to play Ping Pong.",
    categories: ["Sports", "Outdoor"],
    tags: ["ping pong", "table tennis"],
    owner: [{ name: "Peter Ulrich", url: "https://peterulrich.net/" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "world-002",
    title: "Wheelmap",
    url: "https://wheelmap.org/search",
    imageUrl: "https://mapfinder.org/images/wheelmap_org.jpg",
    description: "Find wheelchair accessible places worldwide.",
    categories: ["Accessibility", "Mobility", "OSM Projects"],
    tags: ["wheelchair", "inclusive"],
    owner: [{ name: "Sozialhelden e.V.", url: "https://www.sozialhelden.de/" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "world-003",
    title: "The Tasteatlas",
    url: "https://www.tasteatlas.com/map",
    imageUrl: "https://mapfinder.org/images/tasteatlas_com.jpg",
    description: "Discover local ingredients, traditional dishes & authentic restaurants.",
    categories: ["Food", "Drinks"],
    tags: ["local food", "restaurants", "traditions", "atlas"],
    owner: [{ name: "Atlas Media", url: "https://www.atlasmedia.hr/" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },
   {
    id: "world-004",
    title: "Sensor.Community",
    url: "https://sensor.community/",
    imageUrl: "https://mapfinder.org/images/sensor_community.jpg",
    description: "A contributors driven global sensor network that creates Open Environmental Data.",
    categories: ["Sustainability", "Technology", "Nature"],
    tags: ["environmental data", "sensors"],
    owner: [{ name: "Open Data Stuttgart", url: "https://github.com/opendata-stuttgart" }],
    language: "multiple", 
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "world-005",
    title: "The Map of Tomorrow",
    url: "https://www.kartevonmorgen.org/en/home/",
    imageUrl: "https://mapfinder.org/images/kartevonmorgen_org.jpg",
    description: "An interactive online platform for initiatives of change and sustainable businesses.",
    categories: ["Sustainability"],
    tags: ["shopping"],
    owner: [{ name: "Ideen³ e.V.", url: "" }],
    language: "multiple",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "world-006",
    title: "Submarine Cable Map",
    url: "https://www.submarinecablemap.com/",
    imageUrl: "https://mapfinder.org/images/submarinecablemap_com.jpg",
    description: "Visualization of the global network of undersea fiber-optic cables responsible for carrying 99% of international data traffic.",
    categories: ["Technology"],
    tags: ["internet", "cable", "submarine", "infrastructure"],
    owner: [{ name: "TeleGeography", url: "https://www2.telegeography.com/" }],
    language: "English",
    mapProvider: "Google",
    world: true,
  },
  {
    id: "world-007",
    title: "Astroviewer",
    url: "https://astroviewer.net/iss/en/index.php",
    imageUrl: "https://mapfinder.org/images/astroviewer_net.jpg",
    description: "Track the positions of the International Space Station ISS and the Chinese Space Station Tiangong. Find sighting opportunities for any location of your choice.",
    categories: ["Technology"],
    tags: ["iss", "tiangong", "space"],
    owner: [{ name: "Dirk Matussek", url: "https://www.matussek.com/en/" }],
    language: "en, de, pt",
    mapProvider: "NASA",
    world: true,
  },
  {
    id: "world-008",
    title: "Hood Maps",
    url: "https://hoodmaps.com/new-york-city-neighborhood-map",
    imageUrl: "https://mapfinder.org/images/hoodmaps_com.jpg",
    description: "A crowdsourced map to color-code cities into different areas. Based on the categories: hipsters, tourists, rich, normies, suits and students. + Funny, biased, sometimes sarcastic user reviews.",
    categories: ["Culture"],
    tags: ["fun", "sarcastic", "stereotypes"],
    owner: [{ name: "Pieter Levels", url: "https://x.com/levelsio" }],
    language: "English",
    mapProvider: "MapLibre",
    world: true,
  },
  {
    id: "world-009",
    title: "Calimoto",
    url: "https://calimoto.com/en/motorcycle-trips",
    imageUrl: "https://mapfinder.org/images/calimoto_com.jpg",
    description: "A motorcycle trip-planner with a winding roads algorithm. Use the Discover-section to find bike trips explored by other users.",
    categories: ["Mobility"],
    tags: ["motorcyle", "motorbikes", "trip planner"],
    owner: [{ name: "Russmedia", url: "https://www.russmedia.com/en/" }],
    language: "multiple",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "world-010",
    title: "BVB supporterclubs",
    url: "https://maphub.net/nicovadoy/bvb_worldmap",
    imageUrl: "https://mapfinder.org/images/bvbnorge_no.jpg",
    description: "Supporterclubs, pubs and other locations linked to Borussia Dortmund around the world.",
    categories: ["Sports"],
    tags: ["soccer", "BVB", "fanclubs", "supporterclubs"],
    owner: [{ name: "BVB Norway - Borussentrolle", url: "https://www.bvbnorge.no/" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "world-011",
    title: "1NITE TENT",
    url: "https://1nitetent.com/",
    imageUrl: "https://mapfinder.org/images/1nitetent_com.jpg",
    description: "One Night Tent works like Couchsurfing - but outdoors. Outdoor enthusiasts, travelers, and hikers can access the spot online and camp there for one night - without any exchange of goods or services.",
    categories: ["Nature", "Outdoor"],
    tags: ["camping", "tent", "couchsurfing", "overnight"],
    owner: [{ name: "1Nite Tent", url: "" }],
    language: "en, de",
    mapProvider: "OSM",
    world: true,
  },
    {
    id: "world-012",
    title: "Landlord Tech Watch",
    url: "https://antievictionmappingproject.github.io/landlordtech/",
    imageUrl: "https://mapfinder.org/images/antievictionmap_com.jpg",
    description: "Landlord Tech: technical products and platforms that lead to surveillance and speculation in the real estate industrie, both tied up in gentrification.",
    categories: ["Technology"],
    tags: ["surveillance", "tenant", "gentrification", "tech watch"],
    owner: [{ name: "Anti-Eviction Mapping Project", url: "https://antievictionmap.com/" },
            { name: "Anti-Eviction Lab", url: "https://www.antievictionlab.org/" },
            { name: "Ocean Hill-Brownsville Alliance", url: "" },
            { name: "People Power Media", url: "https://www.peoplepowermedia.org/" },
            { name: "AI Now Institute", url: "https://ainowinstitute.org/" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },
   {
    id: "world-013",
    title: "Virtual Museum of Dead Places",
    url: "https://vimudeap.info/de/atlas/",
    imageUrl: "https://mapfinder.org/images/vimudeap_info.jpg",
    description: "As a research project of the Berlin University of Applied Sciences, the project aims to collect dead places globally, to present and reflect on them from different perspectives.",
    categories: ["History"],
    tags: ["abandoned", "ruins", "lost places"],
    owner: [{ name: "HTW Berlin", url: "https://www.htw-berlin.de/en/" }],
    language: "German",
    mapProvider: "Google",
    world: true,
  },
  {
    id: "world-014",
    title: "Wplace",
    url: "https://wplace.live/",
    imageUrl: "https://mapfinder.org/images/wplace_live.jpg",
    description: "A collaborative, real-time pixel canvas layered over the world map, where anyone can paint and create art together.",
    categories: ["Arts"],
    tags: ["pixel art", "real-time"],
    owner: [{ name: "Wplace", url: "" }],
    language: "multiple",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "world-015",
    title: "HVO/XtL gas stations",
    url: "https://www.google.com/maps/d/viewer?mid=1sL1dIiegNJiRlVzG6_QgnWuko1A6VuU&femb=1",
    imageUrl: "https://mapfinder.org/images/efuelsnow_de.jpg",
    description: "Find gas stations with HVO / XtL diesel.",
    categories: ["Mobility", "Sustainability"],
    tags: ["HVO", "XTL", "gas stations", "diesel", "cars"],
    owner: [{ name: "eFuelsNow e.V.", url: "https://efuelsnow.de/" }],
    language: "de, en",
    mapProvider: "Google",
    world: true,
  },
  {
    id: "world-016",
    title: "iNaturalist",
    url: "https://www.inaturalist.org/observations?subview=map",
    imageUrl: "https://mapfinder.org/images/inaturalist_org.jpg",
    description: "An online social network for sharing biodiversity information to help each other learn about nature. It's also a crowdsourced species identification system and an organism occurrence recording tool.",
    categories: ["Nature"],
    tags: ["biodiversity", "identification", "animals", "plants", "fungus"],
    owner: [{ name: "iNaturalist", url: "" }],
    language: "multiple",
    mapProvider: "Google",
    world: true,
  },
  {
    id: "world-017",
    title: "Licence to Locate",
    url: "https://licencetolocate.com/",
    imageUrl: "https://mapfinder.org/images/licencetolocate_com.jpg",
    description: "An unofficial, fan-built atlas of every James Bond filming location, from Dr. No (1962) to No Time to Die (2021).",
    categories: ["Arts"],
    tags: ["james bond", "007", "movies", "film sets", "last"],
    owner: [{ name: "An anonymous Bond fan", url: "" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },



  //Africa,
  {
    id: "afr-001",
    title: "Unganisha",
    url: "https://www.erlebnis-unganisha.de/",
    imageUrl: "https://mapfinder.org/images/erlebnis_unganisha_de.jpg",
    description: "Discover the WWF initiative Unganisha. This natural region in East Africa is home to eight national protected areas, including the Serengeti and Kilimanjaro National Parks, and 43 community protected areas. This map aims to raise awareness about the large-scale implementation of a protected area network and their ongoing conservation efforts.",
    categories: ["Nature", "Sustainability"],
    continent: "Africa",
    countries: ["Kenya", "Tanzania"],
    tags: ["development", "ecosystems", "education", "charity", "immersive", "audio guide", "last"],
    owner: [{ name: "WWF.de", url: "https://www.wwf.de" }],
    language: "German",
    mapProvider: "custom-built",
  },



   //Asia,Indonesia,Nusantara
  {
    id: "as-id-nusantara-001",
    title: "Peta Nusantara",
    url: "https://petanusantara.id/en/peta-ikn",
    imageUrl: "https://mapfinder.org/images/petanusantara_id.jpg",
    description: "Indonesia is building a new capital, Nusantara. This map provides you with an overview of construction projects and related information. (Ad-blocker recommended)",
    categories: ["History", "Accessibility"],
    continent: "Asia",
    countries: ["Indonesia"],
    states: ["East Kalimantan"],
    cities: ["Nusantara"],
    tags: ["construction sites", "development", "city guide", "last"],
    owner: [{ name: "Muhammad Fadhlurrohman", url: "https://www.fadhlur.com/" }],
    language: "en, id, nl",
    mapProvider: "OSM",
  },



  //Europe
  {
    id: "eu-01",
    title: "Mundraub",
    url: "https://mundraub.org/",
    imageUrl: "https://mapfinder.org/images/mundraub_org.jpg",
    description: "A platform for the discovery of eatible landscapes. Mundraub creates awareness of regionality and seasonality and wants to motivate you to perceive and use your surroundings in culinary terms.",
    categories: ["Sustainability", "Food", "Nature"],
    continent: "Europe",
    countries: ["Germany", "Switzerland", "Austria"],
    tags: ["trees", "seasonality", "local food"],
    owner: [{ name: "Terra Concordia", url: "" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-02",
    title: "Reparatur-Initiativen",
    url: "https://www.reparatur-initiativen.de/orte",
    imageUrl: "https://mapfinder.org/images/reparatur-initiativen_de.jpg",
    description: "Find, support and found repair initiatives (Repair-Places, Reparier-Bars, Repair Cafés etc.).",
    categories: ["Sustainability", "Support"],
    continent: "Europe",
    countries: ["Germany", "Switzerland", "Austria"],
    tags: ["workshops", "repair"],
    owner: [{ name: "Anstiftung", url: "https://anstiftung.de/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-03",
    title: "Parkinson related locations",
    url: "https://maphub.net/teamdopamin/parkinson-karte",
    imageUrl: "https://mapfinder.org/images/parkinson_karte.jpg",
    description: "A map of parkinson related locations in Germany, Switzerland and Austria.",
    categories: ["Health", "Support"],
    continent: "Europe",
    countries: ["Germany", "Switzerland", "Austria"],
    tags: ["parkinson", "help"],
    owner: [{ name: "TeamDopamin", url: "" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-04",
    title: "Open Workshops",
    url: "https://offene-werkstaetten.org/en/workshop-search",
    imageUrl: "https://mapfinder.org/images/offene-werkstaetten_org.jpg",
    description: "The Network of open workshops.",
    categories: ["Sustainability", "Support"],
    continent: "Europe",
    countries: ["Germany", "Switzerland", "Austria"],
    tags: ["workshops", "repair"],
    owner: [{ name: "Verbund Offener Werkstätten e.V.", url: "" }],
    language: "en, de",
    mapProvider: "OSM",
  },
  {
    id: "eu-05",
    title: "Nette Toilette",
    url: "https://www.die-nette-toilette.de/standorte.html",
    imageUrl: "https://mapfinder.org/images/die_nette_toilette_de.jpg",
    description: "This map shows businesses that provide free access to their toilets. With over 400 cities and municipalities participating in the DACH region.",
    categories: ["Accessibility", "Support"],
    continent: "Europe",
    countries: ["Germany", "Switzerland", "Austria"],
    tags: ["toilet", "restroom", "help", "last"],
    owner: [{ name: "Wahl-Druck GmbH", url: "https://www.wahl-druck.de/" }],
    language: "German",
    mapProvider: "Google",
  },
  {
    id: "eu-06",
    title: "Na ovoce",
    url: "https://map.na-ovoce.cz/",
    imageUrl: "https://mapfinder.org/images/na_ovoce_cz.jpg",
    description: "A community platform for people who want to responsibly make use of natural resources in the form of wild-growing fruit trees, shrubs, and herbs.",
    categories: ["Sustainability", "Food", "Nature"],
    continent: "Europe",
    countries: ["Czechia", "Slovakia"],
    tags: ["trees", "seasonality", "local food", "last"],
    owner: [{ name: "Na ovoce, z.s.", url: "" }],
    language: "Czech",
    mapProvider: "OSM",
  },
 

  
  //Europe,Czechia
  {
    id: "eu-cz-001",
    title: "Metroskop",
    url: "https://metroskop.cz/",
    imageUrl: "https://mapfinder.org/images/metroskop_cz.jpg",
    description: "An interactive 3D visualization of Prague's metro system. Explore the entire network, see how deep the stations actually are, follow the tunnels underground, and discover some lesser-known parts of the system.",
    categories: ["History", "Mobility"],
    continent: "Europe",
    countries: ["Czechia"],
    cities: ["Prague"],
    tags: ["subway", "metro", "immersive", "last"],
    owner: [{ name: "Antonin Kus", url: "https://antoninkus.com/" }],
    language: "en, cs",
    mapProvider: "ČÚZK",
  },



  //Europe,England
  {
    id: "eu-gb-001",
    title: "Hertfordshire Walker",
    url: "https://www.hertfordshirewalker.uk/",
    imageUrl: "https://mapfinder.org/images/hertfordshirewalker_uk.jpg",
    description: "A collection of 300 free walks suitable for all ages, from an hour-long potter to half-day hikes.",
    categories: ["Sports", "Nature", "Outdoor"],
    continent: "Europe",
    countries: ["England"],
    states: ["Hertfordshire"],
    tags: ["walks", "hikes"],
    owner: [{ name: "Ellie and Dave Brewer", url: "" }],
    language: "English",
    mapProvider: "OSM",
  },
  {
    id: "eu-gb-mirfield-001",
    title: "Interactive History Map",
    url: "https://maphub.net/Mirfield-Archive/Mirfield-History-Map",
    imageUrl: "https://mapfinder.org/images/Mirfield-History-Map.jpg",
    description: "A group project to build an interactive history map of Mirfield, England.",
    categories: ["History"],
    continent: "Europe",
    countries: ["England"],
    states: ["West Yorkshire"],
    districts: ["Kirklees"],
    cities: ["Mirfield"],
    tags: ["education"],
    owner: [{ name: "Facebook group", url: "https://www.facebook.com/groups/1810957312502477/" }],
    language: "English",
    mapProvider: "OSM",
  },



  //Europe,France
  {
    id: "eu-fr-001",
    title: "Var 1944",
    url: "https://var1944.var.fr/en/list",
    imageUrl: "https://mapfinder.org/images/var1944_var_fr.jpg",
    description: "Through 80 fascinating portraits, you can discover the exciting history of Operation Dragoon and the Liberation of France in the Second World War.",
    categories: ["History"],
    continent: "Europe",
    countries: ["France"],
    states: ["Provence-Alpes-Côte d’Azur"],
    districts: ["Var"],
    tags: ["immersive", "ww2", "war", "operation dragoon", "audio guide"],
    owner: [{ name: "Departmental Council of Var", url: "https://var.fr/" }],
    language: "en, fr, it",
    mapProvider: "custom-built",
  },
  {
    id: "eu-fr-marseille-001",
    title: "Marseille 2021",
    url: "https://marseille.laphase5.com/en",
    imageUrl: "https://mapfinder.org/images/marseille_laphase5_com.jpg",
    description: "An immersive experience of the entire city that faithfully reproduces its topography and its cartography.",
    categories: ["Culture"],
    continent: "Europe",
    countries: ["France"],
    states: ["Provence-Alpes-Côte d’Azur"],
    districts: ["Bouches-du-Rhône"],
    cities: ["Marseille"],
    tags: ["immersive", "city guide"],
    owner: [{ name: "La Phase 5", url: "https://pha5e.com/" }],
    language: "en, fr",
    mapProvider: "OSM",
  },



  //Europe,Germany
  {
    id: "eu-de-001",
    title: "Trimm-Dich-Pfade",
    url: "https://www.trimm-dich-pfad.com/standorte",
    imageUrl: "https://mapfinder.org/images/trimm-dich-pfad_com.jpg",
    description: "Find fitness trails around Germany.",
    categories: ["Sports", "Nature", "Outdoor"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["trimm dich pfad", "calisthenics", "fitness"],
    owner: [{ name: "Outgym", url: "https://outgym.de/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-002",
    title: "Altkleiderspenden",
    url: "https://altkleiderspenden.de/",
    imageUrl: "https://mapfinder.org/images/altkleiderspenden_de.jpg",
    description: "Find places to donate old clothes to.",
    categories: ["Sustainability", "Support"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["donations", "charity", "recycling"],
    owner: [{ name: "FairWertung e. V.", url: "https://fairwertung.de/" }],
    language: "German",
    mapProvider: "Google",
  },
  {
    id: "eu-de-003",
    title: "Medical on-call practices",
    url: "https://bereitschaftspraxen.116117.de/",
    imageUrl: "https://mapfinder.org/images/kbv_de.jpg",
    description: "Are you sick and the doctor's offices are closed? Are you not life-threateningly ill, but cannot wait until the next consultation time? Then doctors in on-call offices will help you. There is also a search tool for doctors or psychotherapist.",
    categories: ["Health", "Accessibility"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["doctors", "help", "psychotherapist", "medical"],
    owner: [{ name: "Kassenärztliche Bundesvereinigung", url: "https://www.kbv.de/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-004",
    title: "Einmal ohne, bitte",
    url: "https://einmalohnebitte.de/karte/",
    imageUrl: "https://mapfinder.org/images/einmalohnebitte_de.jpg",
    description: "Simply buy packaging-free. Find local shopping opportunities where you can shop with your own container.",
    categories: ["Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["shopping", "packaging-free", "waste-free"],
    owner: [{ name: "rehab republic e.V.", url: "https://rehab-republic.de/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-005",
    title: "Mokli",
    url: "https://mokli-help.de/#/",
    imageUrl: "https://mapfinder.org/images/mokli-help_de.jpg",
    description: "A help-platform for people in need. Mokli helps you to find food, places to sleep, shower facilities, advice centers and free doctors.",
    categories: ["Support", "Accessibility"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["help"],
    owner: [{ name: "KARUNA eG", url: "https://karuna.family/" }],
    language: "multiple",
    mapProvider: "Google",
  },
  {
    id: "eu-de-006",
    title: "Müll nicht rum",
    url: "https://muellnichtrum.rlp.de/",
    imageUrl: "https://mapfinder.org/images/muellnichtrum_rlp_de.jpg",
    description: "'Don't litter' provides you with information on how to avoid garbage. Besides of helpful facts, you can find e.g. locations that cooperate with projects like 'Recup'.",
    categories: ["Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["shopping", "packaging-free", "waste-free", "recycling"],
    owner: [{ name: "MKUEM Rheinland-Pfalz", url: "https://mkuem.rlp.de/" }],
    language: "German",
    mapProvider: "Google",
  },
  {
    id: "eu-de-007",
    title: "Refill Deutschland",
    url: "https://refill-deutschland.de/karte/",
    imageUrl: "https://mapfinder.org/images/refill_deutschland_de.jpg",
    description: "The concept of Refill Germany is simple: Stores with the refill sticker on the window/door, will refill your drinking vessel with tab water for free.",
    categories: ["Sustainability", "Drinks"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["water", "waste-free", "packaging-free"],
    owner: [{ name: "a tip: tap e.V.", url: "https://atiptap.org/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-008",
    title: "Urban Community Gardens",
    url: "https://urbane-gaerten.de/urbane-gaerten/gaerten-im-ueberblick",
    imageUrl: "https://mapfinder.org/images/urbane-gaerten_de.jpg",
    description: "Find information and tools for organizing and communicating.",
    categories: ["Family", "Nature", "Outdoor"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["urban", "community", "gardens"],
    owner: [{ name: "Anstiftung", url: "https://anstiftung.de/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-009",
    title: "Harnstoff-Zapfsäulen",
    url: "https://www.google.com/maps/d/viewer?mid=1pxtJk_oy2H-9TdtA_EjROi5CMD4&ll=50.47102111380881%2C8.989647020283686&z=6",
    imageUrl: "https://mapfinder.org/images/Harnstoff_Zapfsaeulen.jpg",
    description: "Find gas stations with pumps of 'Diesel exhaust fluid' (like AdBlue).",
    categories: ["Mobility"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["gas stations", "adBlue", "diesel", "cars"],
    owner: [{ name: "motor-talk user", url: "https://www.motor-talk.de/forum/liste-von-tankstellen-mit-speziellen-pkw-adblue-zapfsaeulen-t5520779.html" }],
    language: "German",
    mapProvider: "Google",
  },
  {
    id: "eu-de-010",
    title: "One Night Wild",
    url: "https://www.onenightwild.com/biwakplaetze-und-trekkingplaetze-deutschland-karte/",
    imageUrl: "https://mapfinder.org/images/onenightwild_com.jpg",
    description: "Find places in Germany where you can legally stay overnight in the nature. Whether you are looking for bivouac sites, trekking sites, boofers, water hiking rest areas or nature campsites.",
    categories: ["Nature", "Outdoor"],
    continent: "Europe",
    countries: ["Germany"],
    tags: [ "overnight", "bivouac", "camping", "tent", "last"],
    owner: [{ name: "Benjamin Halmai", url: "https://www.onenightwild.com/wer-steckt-hinter-onenightwild/" }],
    language: "German",
    mapProvider: "Google + OSM",
  },
  {
    id: "eu-de-011",
    title: "meinGrün",
    url: "https://app.meingruen.org/#/",
    imageUrl: "https://mapfinder.org/images/meingruen_org.jpg",
    description: "A web app for discovering green spaces and parks in Heidelberg and Dresden. There is an extensive search function for activities and conditions.",
    categories: ["Family", "Nature", "Outdoor"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Dresden", "Heidelberg"],
    tags: ["parks", "green spaces"],
    owner: [{ name: "The Leibniz Institute of Ecological Urban and Regional Development", url: "https://www.ioer.de/en/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-012",
    title: "Wohin damit?",
    url: "https://www.wohindamit.org/?lat=49&lon=10&zoom=8",
    imageUrl: "https://mapfinder.org/images/wohindamit_org.jpg",
    description: "Find places that accept donations of everyday stuff like books, toys, clothes, furniture etc..",
    categories: ["Sustainability", "Support"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["donations", "charity", "recycling"],
    owner: [{ name: "Peter Wehner", url: "" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-013",
    title: "Charging Stations",
    url: "https://www.bundesnetzagentur.de/DE/Fachthemen/ElektrizitaetundGas/E-Mobilitaet/Ladesaeulenkarte/start.html",
    imageUrl: "https://mapfinder.org/images/bundesnetzagentur_de.jpg",
    description: "Publicly accessible charging infrastructure in Germany reported under the Ladesäulenverordnung (LSV).",
    categories: ["Mobility", "Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["charging stations", "cars", "gas stations"],
    owner: [{ name: "Bundesnetzagentur", url: "https://www.bundesnetzagentur.de/" }],
    language: "German",
    mapProvider: "basemap",
  },
  {
    id: "eu-de-014",
    title: "Bewegungslandkarte",
    url: "https://app.bewegungslandkarte.de/",
    imageUrl: "https://mapfinder.org/images/bewegungslandkarte_de.jpg",
    description: "With the Movement-Map of the DOSB you can easily find suitable sports and exercise places near you.",
    categories: ["Sports", "Health"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["sports clubs", "fitness"],
    owner: [{ name: "Deutscher Olympischer Sportbund e.V.", url: "https://www.dosb.de/" }],
    language: "German",
    mapProvider: "Google",
  },
  {
    id: "eu-de-015",
    title: "Bäderatlas",
    url: "https://baederatlas.com/",
    imageUrl: "https://mapfinder.org/images/baederatlas_com.jpg",
    description: "This atlas provides information for swimming spots in Germany.",
    categories: ["Family","Sports", "Nature", "Outdoor"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["swimming", "pools", "beaches", "atlas", "lakes", "fitness"],
    owner: [{ name: "Deutsche Gesellschaft für das Badewesen e.V.", url: "https://www.dgfdb.de/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-016",
    title: "The Oderbruch",
    url: "https://www.kulturerbe-oderbruch.de/en/home-page/",
    imageUrl: "https://mapfinder.org/images/kulturerbe_oderbruch_de.jpg",
    description: "Located on the German-Polish border in eastern Brandenburg, the Oderbruch is the largest populated river polder in Europe. It was the first cultural landscape in Europe to be awarded the European Heritage Label. Use the map to find more than 40 cultural heritage sites and all the latest event information.",
    categories: ["Arts","Culture", "History"],
    continent: "Europe",
    countries: ["Germany"],
    states: ["Brandenburg"],
    tags: ["heritage label", "events"],
    owner: [{ name: "intermunicipal working group", url: "" }],
    language: "en, de, pl",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-017",
    title: "E-Schrott-entsorgen",
    url: "https://entsorgungsstellen.e-schrott-entsorgen.org/suche",
    imageUrl: "https://mapfinder.org/images/e_schrott_entsorgen_org.jpg",
    description: "Find places where you can drop off electronic waste for free.",
    categories: ["Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    tags: ["recycling", "last"],
    owner: [{ name: "stiftung ear", url: "https://www.stiftung-ear.de/" }],
    language: "German",
    mapProvider: "OSM",
  },

  

//Europe,Germany,Berlin
   {
    id: "eu-de-berlin-001",
    title: "Abandoned Berlin",
    url: "https://www.abandonedberlin.com/map",
    imageUrl: "https://mapfinder.org/images/abandonedberlin_com.jpg",
    description: "Useful guides, to help people reach abandoned places, to discover some of the stories and detail of the difficulties/hazards involved.",
    categories: ["History"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["abandoned", "ruins", "lost places"],
    owner: [{ name: "Ciarán Fahey", url: "https://bio.site/cfahey" }],
    language: "English",
    mapProvider: "Google",
  },
  {
    id: "eu-de-berlin-002",
    title: "Berliner Sessions",
    url: "https://berlinersessions.de/?sprache=en",
    imageUrl: "https://mapfinder.org/images/berlinersessions_de.jpg",
    description: "Open Mic, Open Stage or Jam Session in Berlin.",
    categories: ["Nightlife"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["open-mic", "open-stage", "jam session", "events", "music"],
    owner: [{ name: "mrhide.de", url: "https://mrhide.de/" }],
    language: "en, de",
    mapProvider: "OSM",
  },
   {
    id: "eu-de-berlin-003",
    title: "Ubahn-Map",
    url: "https://ubahn-map.com/",
    imageUrl: "https://mapfinder.org/images/ubahn-map_com.jpg",
    description: "This interactive map shows you subway stations with Wikipedia information and you can plan your journey using the built-in route finder.",
    categories: ["History", "Mobility"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["subway", "metro"],
    owner: [{ name: "skamsie", url: "https://skamsie.ro/" }],
    language: "English",
    mapProvider: "custom-built",
  },
  {
    id: "eu-de-berlin-004",
    title: "Berlin Besetzt",
    url: "https://www.berlin-besetzt.de/",
    imageUrl: "https://mapfinder.org/images/berlin_besetzt_de.jpg",
    description: "This illustrated map shows the history of squatting in Berlin as an example of self-empowered intervention by protest movements in urban space and urban life.",
    categories: ["History"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["squatting", "protest", "education"],
    owner: [{ name: "Pappsatt Medienkollektiv", url: "" },
           { name: "reclaimyourcity.net", url: "" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-005",
    title: "HistoMap Berlin",
    url: "https://histomapberlin.de/en/index.html",
    imageUrl: "https://mapfinder.org/images/histomapberlin_de.jpg",
    description: "On the basis of geo-referenced historical maps, HistoMap Berlin is a plot precise search for Berlin from 1910 to 2023.",
    categories: ["History"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["historical maps"],
    owner: [{ name: "Berlin State Archive", url: "https://landesarchiv-berlin.de/en/the-landesarchiv-berlin" },
           { name: "Berliner Hochschule für Technik", url: "https://www.bht-berlin.de/en/" }],
    language: "en, de",
    mapProvider: "Geoportal Berlin",
  },
  {
    id: "eu-de-berlin-006",
    title: "Bars & Pubs",
    url: "https://maphub.net/barsaroundme/berlin",
    imageUrl: "https://mapfinder.org/images/barsandpubs.jpg",
    description: "A map I made myself; the one that led to the creation of 'mapfinder'. A few of the 1000+ existing bars & kneipen in Berlin. Last entry from 2018!",
    categories: ["Drinks", "Nightlife"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["bars", "pubs", "beer", "wine", "cocktails"],
    owner: [{ name: "Michel Burmeister", url: "" }],
    language: "English",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-007",
    title: "Club Map",
    url: "https://maphub.net/RadicalLiving/berlin-club-map",
    imageUrl: "https://mapfinder.org/images/radical_living_net.jpg",
    description: "Some clubs of Berlin",
    categories: ["Nightlife"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["clubs", "party", "music"],
    owner: [{ name: "Radical Living", url: "https://www.radical-living.net/" }],
    language: "English",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-008",
    title: "Kita Expert",
    url: "https://kita.expert/search",
    imageUrl: "https://mapfinder.org/images/kita_expert.jpg",
    description: "Get help finding a Kita in Berlin (Daycare center).",
    categories: ["Family", "Accessibility"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["kitas", "parenting", "daycare"],
    owner: [{ name: "Makers'Den", url: "https://makersden.io/" }],
    language: "English",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-009",
    title: "shotinberlin.de",
    url: "https://www.shotinberlin.de/en/map/",
    imageUrl: "https://mapfinder.org/images/shotinberlin_de.jpg",
    description: "A website about movies filmed in Berlin and their shooting locations.",
    categories: ["Arts"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["movies", "film sets"],
    owner: [{ name: "Magnus Hildebrandt", url: "" }],
    language: "en, de",
    mapProvider: "Google",
  },
  {
    id: "eu-de-berlin-010",
    title: "Berlin Plattform",
    url: "https://berlin-plattform.de/",
    imageUrl: "https://mapfinder.org/images/berlin_plattform_de.jpg",
    description: "Supports social, ecological and participatory urban development by providing specialist expertise.",
    categories: ["Accessibility", "Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["urban", "development", "gentrification", "politics"],
    owner: [{ name: "ARCH+", url: "https://archplus.net/de/" },
            { name: "& other individuals", url: "" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-011",
    title: "Gieß den Kiez",
    url: "https://www.giessdenkiez.de/",
    imageUrl: "https://mapfinder.org/images/giessdenkiez_de.jpg",
    description: "A platform for coordinating the irrigation of Berlin trees.",
    categories: ["Sustainability", "Nature"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["trees", "irrigation"],
    owner: [{ name: "Technologiestiftung Berlin", url: "https://www.technologiestiftung-berlin.de/" }],
    language: "en, de",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-012",
    title: "Drinking Fountains",
    url: "https://www.bwb.de/de/trinkbrunnen.php",
    imageUrl: "https://mapfinder.org/images/bwb_de.jpg",
    description: "Drinking fountains are directly connected to the Berlin drinking water network and deliver fresh Berlin water from May to October. The water quality is strictly monitored.",
    categories: ["Drinks", "Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["fountains", "water"],
    owner: [{ name: "Berliner Wasserbetriebe", url: "" }],
    language: "multiple",
    mapProvider: "Google",
  },
  {
    id: "eu-de-berlin-013",
    title: "Fairer Stadtplan Berlin",
    url: "https://www.fairerhandel.berlin/fair-city-map-berlin/",
    imageUrl: "https://mapfinder.org/images/fairer_stadtplan_berlin.jpg",
    description: "Find fair trade locations across Berlin where you can either shop, enjoy or get involved.",
    categories: ["Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["fair-trade", "shopping"],
    owner: [{ name: "Faires Berlin e.V.", url: "" }],
    language: "en, de",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-014",
    title: "Hier Baut Berlin",
    url: "https://hierbautberlin.de/map",
    imageUrl: "https://mapfinder.org/images/hierbautberlin_de.jpg",
    description: "Aggregates information on construction sites on various websites of the city of Berlin and shows them on a map.",
    categories: ["Accessibility"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["construction sites", "development"],
    owner: [{ name: "Bitboxer", url: "https://bodo.tasche.me/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-015",
    title: "Trennt Map",
    url: "https://www.trenntmap.de/",
    imageUrl: "https://mapfinder.org/images/trenntstadt-berlin_de.jpg",
    description: "The Trennt Map is about waste separation, recycling and waste prevention. Get detailed information about product and project descriptions, addresses and opening times etc..",
    categories: ["Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["recycling", "waste-free"],
    owner: [{ name: "Berliner Stadtreinigungsbetriebe (BSR)", url: "https://www.bsr.de/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-016",
    title: "Natur Stadt Berlin",
    url: "https://naturstadt.berlin/karte/",
    imageUrl: "https://mapfinder.org/images/naturstadt_berlin.jpg",
    description: "The network of Berlin coordination offices for nature, environmental, climate and sustainability education has mapped out all the green learning places and treasures of the city's nature.",
    categories: ["Sustainability", "Nature"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["education"],
    owner: [{ name: "Senatsverwaltung für Mobilität, Verkehr, Klimaschutz und Umwelt", url: "https://www.berlin.de/sen/uvk/natur-und-gruen/biologische-vielfalt/umweltbildung/koordinierung/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-017",
    title: "infraVelo",
    url: "https://www.infravelo.de/karte/",
    imageUrl: "https://mapfinder.org/images/infravelo_de.jpg",
    description: "Supports the state of Berlin and its districts in creating new infrastructure for cycling. The map shows an overview of running and completed projects.",
    categories: ["Accessibility", "Mobility", "Sustainability"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["bikes", "bicycle", "cycling", "politics", "development", "infrastructure"],
    owner: [{ name: "Grün Berlin", url: "https://gruen-berlin.de/en/" }],
    language: "German",
    mapProvider: "OSM",
  },
  {
    id: "eu-de-berlin-018",
    title: "TILDA Parkraum",
    url: "https://tilda-geo.de/regionen/parkraum-berlin?map=13.5/52.518/13.3917&config=paakh5.miudh.f6&v=2",
    imageUrl: "https://mapfinder.org/images/tilda_geo_de.jpg",
    description: "Detailed information on parking in public spaces. As well as parking away from public roads, such as private parking spaces (including underground garages).",
    categories: ["Mobility", "Accessibility", "OSM Projects"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Berlin"],
    tags: ["parking", "garages", "cars", "infrastructure"],
    owner: [{ name: "Senatsverwaltung für Mobilität, Verkehr, Klimaschutz und Umwelt", url: "https://www.berlin.de/sen/uvk/natur-und-gruen/biologische-vielfalt/umweltbildung/koordinierung/" }],
    language: "German",
    mapProvider: "OSM",
  },
  
  
//Europe,Germany,Bonn
   {
    id: "eu-de-bonn-001",
    title: "Path of Democracy",
    url: "https://www.wegderdemokratie.de/en",
    imageUrl: "https://mapfinder.org/images/wegderdemokratie_de.jpg",
    description: "Take an exciting and informative tour of the key milestones of the history of the Federal Republic of Germany. The map will take you to 65 sites that have been, and still are, associated with key moments in the history of German post-war democracy.",
    categories: ["History"],
    continent: "Europe",
    countries: ["Germany"],
    states: ["North Rhine-Westphalia"],
    cities: ["Bonn"],
    tags: ["democracy", "last"],
    owner: [{ name: "City of Bonn", url: "https://www.bonn.de/" },
            { name: "HdG", url: "https://www.hdg.de/en/" }],
    language: "en, de",
    mapProvider: "Google",
  },


  
//Europe,Germany,Hamburg
   {
    id: "eu-de-hamburg-001",
    title: "Skate Spots",
    url: "https://skateboardev.de/skatespots/",
    imageUrl: "https://mapfinder.org/images/skateboardev_de.jpg",
    description: "This map helps you to find all known and popular skate spots in Hamburg.",
    categories: ["Sports", "Outdoor"],
    continent: "Europe",
    countries: ["Germany"],
    cities: ["Hamburg"],
    tags: ["skateboard"],
    owner: [{ name: "Skateboard e.V. Hamburg", url: "" }],
    language: "German",
    mapProvider: "Google",
  },


  
  //Europe,Spain
  {
    id: "eu-es-palma-001",
    title: "Fountains and springs",
    url: "https://maphub.net/fontsdetramuntana/palma-antigues",
    imageUrl: "https://mapfinder.org/images/springs_of_palma.jpg",
    description: "Some information and pictures about the water network in the center of Palma.",
    categories: ["History"],
    continent: "Europe",
    countries: ["Spain"],
    states: ["Balearic Islands"],
    cities: ["Palma"],
    tags: ["fountains", "springs", "water"],
    owner: [{ name: "Fonts de Mallorca", url: "https://maphub.net/fontsdetramuntana" }],
    language: "Catalan",
    mapProvider: "OSM",
  },
  {
    id: "eu-es-juzcar-001",
    title: "Smurf village",
    url: "https://maphub.net/Juzcar/mapa",
    imageUrl: "https://mapfinder.org/images/smurfs_juzcar.jpg",
    description: "Júzcar, a small village of about 250 people was chosen by Sony to promote the first Smurf 3D movie in 2011.",
    categories: ["Arts", "History"],
    continent: "Europe",
    countries: ["Spain"],
    states: ["Andalucía"],
    districts: ["Málaga"],
    cities: ["Júzcar"],
    tags: ["smurfs", "movies"],
    owner: [{ name: "Volunteers", url: "https://maphub.net/Juzcar" }],
    language: "Spanish",
    mapProvider: "OSM",
  },


  
  //North America,USA
  {
    id: "na-us-ca-brea-001",
    title: "Art in Public Places",
    url: "https://maphub.net/Mauryeel/breas-art-in-public-places-ii",
    imageUrl: "https://mapfinder.org/images/breasartinpublicplaces_com.jpg",
    description: "The city of Brea, California, has the largest collection of public art pieces in the state of California.",
    categories: ["Arts"],
    continent: "North America",
    countries: ["USA"],
    states: ["California"],
    districts: ["Orange County"],
    cities: ["Brea"],
    tags: ["public art", "audio guide"],
    owner: [{ name: "Dena Sommer and Terry Sullivan", url: "https://breasartinpublicplaces.com/home/about-us/" }],
    language: "English",
    mapProvider: "OSM",
  },
  {
    id: "na-us-ny-nyc-001",
    title: "The Welikia Project",
    url: "https://www.welikia.org/map-explorer#9.5/40.7213/-73.9741",
    imageUrl: "https://mapfinder.org/images/welikia_org.jpg",
    description: "Drawing from historical research and scientific modeling, the project visualizes the block-by-block ecosystems, geologic foundations, and stewards of the land before New York.",
    categories: ["History", "Sustainability", "Nature"],
    continent: "North America",
    countries: ["USA"],
    cities: ["New York City"],
    tags: ["ecosystems", "historical maps"],
    owner: [{ name: "New York Botanical Garden", url: "https://www.nybg.org/plant-research-and-conservation/science-programs/center-for-conservation-strategy/urban-conservation/" }],
    language: "English",
    mapProvider: "OSM",
  },
  {
    id: "na-us-wa-aberdeen-001",
    title: "Grungeology",
    url: "https://www.grungeology.org/",
    imageUrl: "https://mapfinder.org/images/grungeology_org.jpg",
    description: "Discover the story of Kurt Cobain and the roots of the grunge movement, uniquely tied to Grays Harbor County. Experience Kurt's early life, the local influences that shaped his music, and the cultural impact.",
    categories: ["Arts", "Culture", "History"],
    continent: "North America",
    countries: ["USA"],
    states: ["Washington"],
    districts: ["Grays Harbor County"],
    tags: ["music", "kurt cobain", "grunge", "biography", "audio guide", "last"],
    owner: [{ name: "The Music Project", url: "https://www.themusicproject.org/" }],
    language: "English",
    mapProvider: "custom-built",
  },
 
  

  //OSM
  {
    id: "osm-001",
    title: "Open Brewery Map",
    url: "https://brewmap.openstreetmap.de/",
    imageUrl: "https://mapfinder.org/images/brewmap_openstreetmap_de.jpg",
    description: "A global map of breweries based on data from Openstreetmap.",
    categories: ["Drinks", "OSM Projects"],
    tags: ["breweries", "beer"],
    owner: [{ name: "Sven Geggus", url: "https://wiki.openstreetmap.org/wiki/User:Giggls" }],
    language: "en, de",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "osm-002",
    title: "Open Camping Map",
    url: "https://opencampingmap.org/",
    imageUrl: "https://mapfinder.org/images/opencampingmap_org.jpg",
    description: "A global map of campgrounds based on data from Openstreetmap.",
    categories: ["Nature", "Outdoor", "OSM Projects"],
    tags: ["camping", "overnight", "tent"],
    owner: [{ name: "Sven Geggus", url: "https://wiki.openstreetmap.org/wiki/User:Giggls" }],
    language: "multiple",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "osm-003",
    title: "Open Infra Map",
    url: "https://openinframap.org/",
    imageUrl: "https://mapfinder.org/images/openinframap_org.jpg",
    description: "A view of the world's infrastructure mapped in the OSM database.",
    categories: ["Technology", "OSM Projects"],
    tags: ["infrastructure"],
    owner: [{ name: "Infrageomatics", url: "https://www.infrageomatics.com/" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "osm-004",
    title: "Open Sea Map",
    url: "https://map.openseamap.org/",
    imageUrl: "https://mapfinder.org/images/openseamap_org.jpg",
    description: "Free nautical database.",
    categories: ["Mobility", "OSM Projects"],
    tags: ["infrastructure", "sea", "nautical"],
    owner: [{ name: "openseamap team", url: "https://openseamap.org/index.php?id=quellen&L=1" }],
    language: "English",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "osm-005",
    title: "Waymarked Trails: Hiking",
    url: "https://hiking.waymarkedtrails.org/",
    imageUrl: "https://mapfinder.org/images/hiking_waymarkedtrails_org.jpg",
    description: "This map shows sign-posted hiking routes around the world.",
    categories: ["Nature", "Outdoor",  "OSM Projects"],
    tags: ["walks", "hikes"],
    owner: [{ name: "lonvia", url: "https://lonvia.de/" },
           { name: "and other maintainer", url: "https://github.com/waymarkedtrails" }],
    language: "multiple",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "osm-006",
    title: "Waymarked Trails: Cycling",
    url: "https://cycling.waymarkedtrails.org/",
    imageUrl: "https://mapfinder.org/images/cycling_waymarkedtrails_org.jpg",
    description: "This map shows sign-posted cycling routes around the world.",
    categories: ["Nature", "Outdoor", "OSM Projects"],
    tags: ["bikes", "bicycle", "cycling"],
    owner: [{ name: "lonvia", url: "https://lonvia.de/" },
           { name: "and other maintainer", url: "https://github.com/waymarkedtrails" }],
    language: "multiple",
    mapProvider: "OSM",
    world: true,
  },
  {
    id: "osm-007",
    title: "OSM Historic Places",
    url: "https://gk.historic.place/",
    imageUrl: "https://mapfinder.org/images/gk_historic_place.jpg",
    description: "POI with historical background on an OSM map.",
    categories: ["History", "OSM Projects"],
    tags: ["education"],
    owner: [{ name: "Lutz Lange and other maintainer", url: "https://wiki.openstreetmap.org/wiki/Historic.Place" }],
    language: "multiple",
    mapProvider: "OSM",
    world: true,
  },
 


];